import React from "react";

const UserTableBody = ({ img, name, time, timeData }) => {
  return (
    <tbody>
      <tr >
        <td >
          <img
            src={img}
            alt="user"
            className="img-fluid img-40 rounded-circle media"
          />
        </td>
        <td className="img-content-box">
          <a className="d-block f-w-500" href="/cuba-context/app/users/profile">
            {name}
          </a>
        </td>
        <td className="text-end">
          <span className="f-light">{time}</span>
          <p className="m-0 font-success">{timeData}</p>
        </td>
      </tr>
    </tbody>
  );
};

export default UserTableBody;
